import WorkItemType from '@/domain/work-item/work-item-type.entity';
import WorkItemRelated from '@/domain/work-item/work-item-related.entity';
import ValidateEntityObject from '@/shared/utils/validate-entity-object';
import WorkItemProject from './work-item-project.entity';

export default class WorkItemDetailed {
  id: string;

  project: WorkItemProject;

  workItemNumber: number;

  title: string;

  status: string;

  workItemType: WorkItemType;

  createdDate: Date;

  originCreatedDate: Date;

  estimatedDeadLine: Date;

  concludedAt: Date;

  createdBy: string;

  assignedTo: string;

  originalEstimate: number;

  storyPoints: number;

  effortSpent: number;

  originSystem: string;

  parent: WorkItemRelated;

  children: WorkItemRelated[];

  description: string;

  errorId ?: string;

  error ?: string;

  eventDate ?: string;

  vstsIntegrationBlocked: boolean = false;

  constructor(obj: any) {
    this.id = obj.id;
    this.project = ValidateEntityObject.validate(obj.project, WorkItemProject.of);
    this.createdDate = obj.createdDate;
    this.originCreatedDate = obj.originCreatedDate;
    this.originSystem = obj.originSystem;
    this.title = obj.title;
    this.workItemNumber = obj.workItemNumber;
    this.estimatedDeadLine = obj.estimatedDeadLine;
    this.concludedAt = obj.concludedAt;
    this.createdBy = obj.createdBy;
    this.assignedTo = obj.assignedTo;
    this.workItemType = ValidateEntityObject.validate(obj.workItemType, WorkItemType.of);
    this.status = obj.status;
    this.originalEstimate = obj.originalEstimate;
    this.storyPoints = obj.storyPoints;
    this.effortSpent = obj.effortSpent || 0;
    this.originSystem = obj.originSystem;
    this.parent = ValidateEntityObject.validate(obj.parent, WorkItemRelated.of);
    this.children = WorkItemRelated.ofList(obj.children);
    this.description = obj.description;
    this.errorId = obj.errorId || '';
    this.error = obj.error || '';
    this.eventDate = obj.eventDate || '';
    this.vstsIntegrationBlocked = obj.vstsIntegrationBlocked || false;
  }

  public static of(value: any): WorkItemDetailed {
    return new WorkItemDetailed(value || {});
  }
}
